export function secondsToHm(d: string | number) {
  d = Number(d)
  const h = Math.floor(d / 3600)
  const m = Math.floor((d % 3600) / 60)
  // const s = Math.floor(d % 3600 % 60);

  const hDisplay = h > 0 ? h + '小时' : ''
  const mDisplay = m > 0 ? m + '分钟' : ''
  // const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
  return hDisplay + mDisplay
}

export function formatDate(time: number | string) {
  //时间戳转日期 13位
  const date = new Date(time)
  const y = date.getFullYear()
  let MM: string | number = date.getMonth() + 1
  MM = MM < 10 ? '0' + MM : MM
  let d: string | number = date.getDate()
  d = d < 10 ? '0' + d : d
  let h: string | number = date.getHours()
  h = h < 10 ? '0' + h : h
  let m: string | number = date.getMinutes()
  m = m < 10 ? '0' + m : m
  let s: string | number = date.getSeconds()
  s = s < 10 ? '0' + s : s
  return {
    y,
    MM,
    d,
    h,
    m,
    s,
  }
}
